import { h } from 'preact'

export const Sitelinks = ({ items }) => {
   return (
      <noscript>
      {items.map((item) => {
            return (
               <a href={item.URL}>{item.title}</a>
            )
         })}
      </noscript>
   )
}
